export default function AppEntry() {
  return (
    <section id="app" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-background-50/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-[200px] h-[200px] bg-background-50/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none"></div>

          <div className="relative flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
                随时随地，吃瓜不迷路
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
                17吃瓜网移动版已全面适配，无论你是通勤路上还是睡前刷瓜，打开浏览器即可畅享最新17吃瓜爆料与明星爆料资讯。无需下载APP，收藏网站即可直达。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-primary-600 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-bookmark-line"></i>
                  收藏到书签
                </button>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 hover:bg-background-50/30 text-background-50 font-semibold text-sm rounded-lg border border-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-share-line"></i>
                  分享给朋友
                </button>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-40 h-48 md:w-48 md:h-56 rounded-3xl bg-background-50/15 border border-background-50/20 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 mx-auto rounded-2xl bg-background-50 flex items-center justify-center mb-3">
                    <i className="ri-smartphone-line text-2xl md:text-3xl text-primary-600"></i>
                  </div>
                  <div className="text-background-50 font-bold text-sm md:text-base">17吃瓜网</div>
                  <div className="text-background-50/60 text-xs mt-1">移动端完美适配</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}